import script from "./logdata.vue?vue&type=script&setup=true&lang=js"
export * from "./logdata.vue?vue&type=script&setup=true&lang=js"

import "./logdata.vue?vue&type=style&index=0&id=e963285e&scoped=true&lang=css"

import exportComponent from "D:\\node\\电脑版Windous\\myOfficial\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e963285e"]])

export default __exports__